import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';

@NgModule({
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule
  ],
  providers: [
    { provide: 'BASE_URL', useFactory: getBaseUrl },
    { provide: 'ORIGIN_URL', useFactory: getBaseUrl },
    { provide: 'IDENTITY_URL', useFactory: identityUrlFactory },
    { provide: 'APP_PATH', useFactory: appPathFactory },
    { provide: 'APP_NAME', useFactory: appNameFactory },
    { provide: 'SITE_MODE', useFactory: siteMode},
    { provide: 'USER_GUIDES', useFactory: userGuides}
  ]
})
export class HirAppBrowserModule {
}

export function getBaseUrl() {
  let baseurl = <string>document.getElementsByTagName('base')[0].href;
  console.log("Your base URL: HIR", baseurl);
  if(baseurl[baseurl.length - 1] === '/')
    return baseurl.slice(0, -1);
  return baseurl;
}

export function apiUrlFactory() {
  return (window as any).urlConfig.apiUrl;
}
export function identityUrlFactory() {
  let data = JSON.parse(document.getElementsByTagName('base')[2].getAttribute('data') || "{}");
  return data.IdentityServerAddress;
}
export function appPathFactory() {
  let data = JSON.parse(document.getElementsByTagName('base')[2].getAttribute('data') || "{}");
  return data.AppPath;
}

export function siteMode() {
  let data =JSON.parse(document.getElementsByTagName('base')[2].getAttribute('data') || "{}");
  return data.SystemMode;
}
export function appNameFactory() {
  //let data =JSON.parse(document.getElementsByTagName('base')[2].getAttribute('data') || "{}");
  return "HIR"; //data.AppName;
}
export function userGuides() {
  let data = JSON.parse(document.getElementsByTagName('base')[2].getAttribute('data') || "{}");
  return data.UserGuides;
}
